const SUPPORTED_LANGS = ['en', 'es', 'de', 'nl', 'pt', 'fr', 'nb', 'sv', 'fi', 'da', 'it'];

const LOCALE_BY_LANG = {
  en: 'en-US',
  es: 'es-ES',
  de: 'de-DE',
  nl: 'nl-NL',
  pt: 'pt-PT',
  fr: 'fr-FR',
  nb: 'nb-NO',
  sv: 'sv-SE',
  fi: 'fi-FI',
  da: 'da-DK',
  it: 'it-IT'
};

const EN = {
  'common.loading': 'Loading...',
  'common.signingOut': 'Signing out...',
  'common.errorLoadingEvent': 'Error loading event',
  'common.loadingEvent': 'Loading event...',
  'common.tryAgain': 'Try Again',
  'common.no': 'No',
  'common.yes': 'Yes',
  'common.confirm': 'Confirm',
  'common.skip': 'Skip',
  'common.share': 'Share',
  'common.logOut': 'Log Out',
  'common.switchAccounts': 'Switch Accounts',
  'common.username': 'Username',
  'common.month': 'Month',
  'common.day': 'Day',
  'common.year': 'Year',
  'common.errorCode': 'Error code:',
  'common.warningAlt': 'Warning',
  'common.profileAlt': 'Profile',
  'common.submitAlt': 'Submit',
  'common.povLogoAlt': 'POV Logo',
  'common.pageTitleUploadPhotos': 'Upload Photos',
  'common.eventNotFoundAlt': 'Event Not Found',
  'common.noUploadsAllowedAlt': 'No Uploads Allowed',
  'common.continueWithGoogleAlt': 'Continue with Google',

  'auth.signInToUploadPhotos': 'Sign In to Upload Photos',
  'auth.continueWithGoogle': 'Continue with Google',
  'auth.openDefaultBrowserForGoogle': 'Please open with your default web browser to sign in with Google',
  'auth.allSignInMethodsFailed': 'All sign-in methods failed',
  'auth.networkError': 'Network error. Please check your connection',
  'auth.tooManySignInAttempts': 'Too many sign-in attempts. Please try again later',
  'auth.accountDisabled': 'This account has been disabled',
  'auth.signInFailed': 'Sign-in failed. Please try again',

  'invalid.noEventFound': 'No Event Found',
  'invalid.eventNotFound': 'Event Not Found',
  'invalid.tryDifferentLink': 'Try a different link',
  'invalid.invalidPovUrl': 'Invalid POV URL',
  'invalid.inputCannotBeEmpty': 'Input cannot be empty.',
  'invalid.enterPovEventUrl': 'Enter a POV event URL',

  'upload.hostDisabledUploads': 'Host Disabled Camera Roll Uploads',
  'upload.noShotsRemaining': 'No uploads remaining',
  'upload.oneShotRemaining': '1 upload remaining',
  'upload.shotsRemaining': '{count} uploads remaining',
  'upload.addShots': 'Add Shots',
  'upload.addMoreShots': 'Add More Shots',
  'upload.uploadingPhotos': 'Uploading photos...',
  'upload.processingPhotos': 'Processing {current} of {total} photos',
  'upload.progressPhotosUploaded': '{current} of {total} photos uploaded',
  'upload.uploadedSummary': 'Uploaded {successful} of {total} images!',
  'upload.noValidPhotos': 'No valid photos to upload. Please try again with different photos.',
  'upload.duplicatePhoto': "You tried adding a photo you've already uploaded",
  'upload.duplicatePhotos': "You tried adding photos you've already uploaded",
  'upload.screenshotsNotAllowed': "Screenshots aren't allowed",
  'upload.screenshotIncluded.one': '{count} screenshot included',
  'upload.screenshotIncluded.other': '{count} screenshots included',
  'upload.noDate.one': "{count} photo doesn't have a date",
  'upload.noDate.other': "{count} photos don't have a date",
  'upload.beforeDate.one': '{count} photo was taken before {date}',
  'upload.beforeDate.other': '{count} photos were taken before {date}',
  'upload.afterDate.one': '{count} photo was taken after {date}',
  'upload.afterDate.other': '{count} photos were taken after {date}',
  'upload.photoTakenBeforeEventStart': "A photo was taken before the event's start date. Uploads {validRange}",
  'upload.photosTakenBeforeDate': '{count} photos were taken before {date}. Uploads {validRange}',
  'upload.photoTakenAfterEventEnd': "A photo was taken after the event's end date. Uploads {validRange}",
  'upload.photosTakenAfterDate': '{count} photos were taken after {date}. Uploads {validRange}',
  'upload.invalidTypePhoto': "A photo isn't a .PNG, .JPG, or .HEIC. {hint}",
  'upload.invalidTypePhotos': "{count} photos aren't a .PNG, .JPG, or .HEIC. {hint}",
  'upload.photoNoDate': "A photo doesn't have a date. {hint}",
  'upload.photosNoDate': "{count} photos don't have dates. {hint}",
  'upload.tooManyPhotosSelected': 'Too many photos selected. {hint}',
  'upload.hint.deleteSomeFirst': 'In order to add more uploads, delete some first.',
  'upload.hint.selectBestPhoto': 'Select your best photo!',
  'upload.hint.selectBestPhotos': 'Select your best {count} photos!',
  'upload.hint.rangeBetween': '{countLabel} taken between {start} and {end} will be accepted',
  'upload.hint.rangeAfter': '{countLabel} taken after {start} will be accepted',
  'upload.rangeBetweenAccepted': 'taken between {start} and {end} will be accepted',
  'upload.rangeAfterAccepted': 'taken after {start} will be accepted',
  'upload.onePhoto': '1 photo',
  'upload.upToPhotos': 'Up to {count} photos',
  'upload.selectBestPhoto': 'Select your best photo!',
  'upload.selectBestPhotos': 'Select your best {count} photos!',
  'upload.willBeAccepted': 'will be accepted',
  'upload.takenBetweenAccepted': '{prefix} taken between {start} and {end} will be accepted',
  'upload.takenAfterAccepted': '{prefix} taken after {start} will be accepted',
  'upload.errorInImage': 'Error in image {index}: {message}',
  'upload.usedAllShotsTap': "You've used all your camera roll shots! Tap one if you change your mind",
  'upload.usedAllShotsDelete': "You've used all your camera roll shots! Delete one if you change your mind",
  'upload.successUploadedOne': 'Successfully uploaded a photo! You have {remaining} remaining',
  'upload.successUploadedMany': 'Successfully uploaded {count} photos! You have {remaining} remaining',
  'upload.povPhotosShownFirst': 'Photos taken with the POV Camera are shown in the gallery first',
  'upload.confirmSubmitTitle': 'Are you sure you want to submit?',
  'upload.moreErrors.one': '+1 more error',
  'upload.moreErrors.other': '+{count} more errors',

  'age.addBirthday': 'Add Birthday',
  'age.underAgeMessage': 'Sorry, you need to be {age} or older to participate in this event. Download the app to create your own event.',
  'age.selectValidDob': 'Please select a valid date of birth',
  'age.selectValidMonth': 'Please select a valid month',
  'age.selectValidDate': 'Please select a valid date',
  'age.failedUpdateDob': 'Failed to update your date of birth. Please try again.',
  'age.goBackValidDob': 'Please go back and select a valid date of birth',
  'age.shareInstagramUsername': 'Share Your Instagram Username',
  'age.theHost': 'the host',
  'age.allowHostRepost': 'Allow {host} to repost shots from today',
  'age.iosApp': 'iOS App',
  'age.androidApp': 'Android App',
  'age.termsAndConditions': 'By confirming your date of birth, you agree to our Terms and Conditions →',

  'time.today': 'today',
  'time.yesterday': 'yesterday',
  'time.at': 'at'
};

const IOS_DUPLICATE = {
  es: {
    'common.loading': 'Cargando...',
    'common.no': 'No',
    'common.yes': 'Sí',
    'common.confirm': 'Confirmar',
    'common.skip': 'Omitir',
    'common.share': 'Compartir',
    'common.logOut': 'Cerrar sesión',
    'common.username': 'Nombre de usuario',
    'common.tryAgain': 'Reintentar',
    'upload.addShots': 'Agregar tomas',
    'upload.noShotsRemaining': 'No quedan tomas',
    'upload.confirmSubmitTitle': '¿Seguro que quieres enviar?',
    'upload.screenshotIncluded.one': '{count} captura de pantalla incluida',
    'upload.screenshotIncluded.other': '{count} capturas de pantalla incluidas',
    'upload.noDate.one': '{count} foto no tiene fecha',
    'upload.noDate.other': '{count} fotos no tienen fecha',
    'upload.beforeDate.one': '{count} foto fue tomada antes de {date}',
    'upload.beforeDate.other': '{count} fotos fueron tomadas antes de {date}',
    'upload.afterDate.one': '{count} foto fue tomada después de {date}',
    'upload.afterDate.other': '{count} fotos fueron tomadas después de {date}',
    'upload.povPhotosShownFirst': 'Las fotos tomadas con la cámara POV se muestran primero en la galería',
    'age.addBirthday': 'Verifica tu fecha de nacimiento',
    'age.allowHostRepost': 'Deja que {host} reposte fotos de hoy',
    'age.termsAndConditions': 'Al confirmar tu fecha de nacimiento, aceptas nuestros Términos y Condiciones →',
    'time.today': 'hoy',
    'time.yesterday': 'ayer'
  },
  de: {
    'common.loading': 'Laden...',
    'common.no': 'Nein',
    'common.yes': 'Ja',
    'common.confirm': 'Bestätigen',
    'common.skip': 'Überspringen',
    'common.share': 'Teilen',
    'common.logOut': 'Abmelden',
    'common.username': 'Benutzername',
    'common.tryAgain': 'Erneut versuchen',
    'upload.addShots': 'Aufnahmen hinzufügen',
    'upload.noShotsRemaining': 'Keine Aufnahmen übrig',
    'upload.confirmSubmitTitle': 'Möchtest du wirklich einreichen?',
    'upload.screenshotIncluded.one': '{count} Screenshot enthalten',
    'upload.screenshotIncluded.other': '{count} Screenshots enthalten',
    'upload.noDate.one': '{count} Foto hat kein Datum',
    'upload.noDate.other': '{count} Fotos haben kein Datum',
    'upload.beforeDate.one': '{count} Foto wurde vor {date} aufgenommen',
    'upload.beforeDate.other': '{count} Fotos wurden vor {date} aufgenommen',
    'upload.afterDate.one': '{count} Foto wurde nach {date} aufgenommen',
    'upload.afterDate.other': '{count} Fotos wurden nach {date} aufgenommen',
    'upload.povPhotosShownFirst': 'Mit der POV-Kamera aufgenommene Fotos werden zuerst in der Galerie angezeigt',
    'age.addBirthday': 'Bestätige dein Geburtsdatum',
    'age.allowHostRepost': 'Erlaube {host}, heutige Fotos zu reposten',
    'age.termsAndConditions': 'Durch Bestätigung deines Geburtsdatums stimmst du unseren AGB zu →',
    'time.today': 'heute',
    'time.yesterday': 'gestern'
  },
  nl: {
    'common.loading': 'Laden...',
    'common.no': 'Nee',
    'common.yes': 'Ja',
    'common.confirm': 'Bevestigen',
    'common.skip': 'Overslaan',
    'common.share': 'Delen',
    'common.logOut': 'Uitloggen',
    'common.username': 'Gebruikersnaam',
    'common.tryAgain': 'Opnieuw proberen',
    'upload.addShots': "Foto's toevoegen",
    'upload.noShotsRemaining': "Geen foto's over",
    'upload.confirmSubmitTitle': 'Weet je zeker dat je wilt indienen?',
    'upload.screenshotIncluded.one': '{count} schermafbeelding inbegrepen',
    'upload.screenshotIncluded.other': '{count} schermafbeeldingen inbegrepen',
    'upload.noDate.one': '{count} foto heeft geen datum',
    'upload.noDate.other': "{count} foto's hebben geen datum",
    'upload.beforeDate.one': '{count} foto is genomen voor {date}',
    'upload.beforeDate.other': "{count} foto's zijn genomen voor {date}",
    'upload.afterDate.one': '{count} foto is genomen na {date}',
    'upload.afterDate.other': "{count} foto's zijn genomen na {date}",
    'upload.povPhotosShownFirst': "Foto's gemaakt met de POV-camera worden eerst getoond in de galerij",
    'age.addBirthday': 'Verifieer je geboortedatum',
    'age.allowHostRepost': 'Laat {host} foto\'s van vandaag reposten',
    'age.termsAndConditions': 'Door je geboortedatum te bevestigen, ga je akkoord met onze Algemene Voorwaarden →',
    'time.today': 'vandaag',
    'time.yesterday': 'gisteren'
  },
  pt: {
    'common.loading': 'Carregando...',
    'common.no': 'Não',
    'common.yes': 'Sim',
    'common.confirm': 'Confirmar',
    'common.skip': 'Pular',
    'common.share': 'Compartilhar',
    'common.logOut': 'Sair',
    'common.username': 'Nome de usuário',
    'common.tryAgain': 'Tentar novamente',
    'upload.addShots': 'Adicionar fotos',
    'upload.noShotsRemaining': 'Nenhuma foto restante',
    'upload.confirmSubmitTitle': 'Tem certeza que deseja enviar?',
    'upload.screenshotIncluded.one': '{count} captura de tela incluída',
    'upload.screenshotIncluded.other': '{count} capturas de tela incluídas',
    'upload.noDate.one': '{count} foto não tem data',
    'upload.noDate.other': '{count} fotos não têm data',
    'upload.beforeDate.one': '{count} foto foi tirada antes de {date}',
    'upload.beforeDate.other': '{count} fotos foram tiradas antes de {date}',
    'upload.afterDate.one': '{count} foto foi tirada após {date}',
    'upload.afterDate.other': '{count} fotos foram tiradas após {date}',
    'upload.povPhotosShownFirst': 'Fotos tiradas com a câmera POV são mostradas primeiro na galeria',
    'age.addBirthday': 'Verifique sua data de nascimento',
    'age.allowHostRepost': 'Permita {host} repostar fotos de hoje',
    'age.termsAndConditions': 'Ao confirmar sua data de nascimento, você concorda com nossos Termos e Condições →',
    'time.today': 'hoje',
    'time.yesterday': 'ontem'
  },
  fr: {
    'common.loading': 'Chargement...',
    'common.no': 'Non',
    'common.yes': 'Oui',
    'common.confirm': 'Confirmer',
    'common.skip': 'Ignorer',
    'common.share': 'Partager',
    'common.logOut': 'Se déconnecter',
    'common.username': "Nom d'utilisateur",
    'common.tryAgain': 'Réessayer',
    'upload.addShots': 'Ajouter des photos',
    'upload.noShotsRemaining': 'Aucune photo restante',
    'upload.confirmSubmitTitle': 'Êtes-vous sûr de vouloir soumettre ?',
    'upload.screenshotIncluded.one': "{count} capture d'écran incluse",
    'upload.screenshotIncluded.other': "{count} captures d'écran incluses",
    'upload.noDate.one': "{count} photo n'a pas de date",
    'upload.noDate.other': "{count} photos n'ont pas de date",
    'upload.beforeDate.one': '{count} photo a été prise avant {date}',
    'upload.beforeDate.other': '{count} photos ont été prises avant {date}',
    'upload.afterDate.one': '{count} photo a été prise après {date}',
    'upload.afterDate.other': '{count} photos ont été prises après {date}',
    'upload.povPhotosShownFirst': 'Les photos prises avec la caméra POV sont affichées en premier dans la galerie',
    'age.addBirthday': 'Vérifiez votre date de naissance',
    'age.allowHostRepost': 'Autorise {host} à reposter les photos',
    'age.termsAndConditions': 'En confirmant votre date de naissance, vous acceptez nos Conditions Générales →',
    'time.today': "aujourd'hui",
    'time.yesterday': 'hier'
  },
  nb: {
    'common.loading': 'Laster...',
    'common.no': 'Nei',
    'common.yes': 'Ja',
    'common.confirm': 'Bekreft',
    'common.skip': 'Hopp over',
    'common.share': 'Del',
    'common.logOut': 'Logg ut',
    'common.username': 'Brukernavn',
    'common.tryAgain': 'Prøv igjen',
    'upload.addShots': 'Legg til bilder',
    'upload.noShotsRemaining': 'Ingen bilder igjen',
    'upload.confirmSubmitTitle': 'Er du sikker på at du vil sende inn?',
    'upload.screenshotIncluded.one': '{count} skjermbilde inkludert',
    'upload.screenshotIncluded.other': '{count} skjermbilder inkludert',
    'upload.noDate.one': '{count} bilde har ingen dato',
    'upload.noDate.other': '{count} bilder har ingen dato',
    'upload.beforeDate.one': '{count} bilde ble tatt før {date}',
    'upload.beforeDate.other': '{count} bilder ble tatt før {date}',
    'upload.afterDate.one': '{count} bilde ble tatt etter {date}',
    'upload.afterDate.other': '{count} bilder ble tatt etter {date}',
    'upload.povPhotosShownFirst': 'Bilder tatt med POV-kameraet vises først i galleriet',
    'age.addBirthday': 'Bekreft fødselsdatoen din',
    'age.allowHostRepost': 'La {host} reposte bilder fra i dag',
    'age.termsAndConditions': 'Ved å bekrefte fødselsdatoen din, godtar du våre vilkår og betingelser →',
    'time.today': 'i dag',
    'time.yesterday': 'i går'
  },
  sv: {
    'common.loading': 'Laddar...',
    'common.no': 'Nej',
    'common.yes': 'Ja',
    'common.confirm': 'Bekräfta',
    'common.skip': 'Hoppa över',
    'common.share': 'Dela',
    'common.logOut': 'Logga ut',
    'common.username': 'Användarnamn',
    'common.tryAgain': 'Försök igen',
    'upload.addShots': 'Lägg till bilder',
    'upload.noShotsRemaining': 'Inga bilder kvar',
    'upload.confirmSubmitTitle': 'Är du säker på att du vill skicka in?',
    'upload.screenshotIncluded.one': '{count} skärmbild inkluderad',
    'upload.screenshotIncluded.other': '{count} skärmbilder inkluderade',
    'upload.noDate.one': '{count} foto saknar datum',
    'upload.noDate.other': '{count} foton saknar datum',
    'upload.beforeDate.one': '{count} foto togs före {date}',
    'upload.beforeDate.other': '{count} foton togs före {date}',
    'upload.afterDate.one': '{count} foto togs efter {date}',
    'upload.afterDate.other': '{count} foton togs efter {date}',
    'upload.povPhotosShownFirst': 'Foton tagna med POV-kameran visas först i galleriet',
    'age.addBirthday': 'Verifiera din födelsedag',
    'age.allowHostRepost': 'Låt {host} reposta bilder från i dag',
    'age.termsAndConditions': 'Genom att bekräfta ditt födelsedatum godkänner du våra villkor →',
    'time.today': 'idag',
    'time.yesterday': 'igår'
  },
  fi: {
    'common.loading': 'Ladataan...',
    'common.no': 'Ei',
    'common.yes': 'Kyllä',
    'common.confirm': 'Vahvista',
    'common.skip': 'Ohita',
    'common.share': 'Jaa',
    'common.logOut': 'Kirjaudu ulos',
    'common.username': 'Käyttäjänimi',
    'common.tryAgain': 'Yritä uudelleen',
    'upload.addShots': 'Lisää kuvia',
    'upload.noShotsRemaining': 'Ei kuvia jäljellä',
    'upload.confirmSubmitTitle': 'Haluatko varmasti lähettää?',
    'upload.screenshotIncluded.one': '{count} kuvakaappaus mukana',
    'upload.screenshotIncluded.other': '{count} kuvakaappausta mukana',
    'upload.noDate.one': '{count} kuvalla ei ole päivämäärää',
    'upload.noDate.other': '{count} kuvalla ei ole päivämäärää',
    'upload.beforeDate.one': '{count} kuva otettu ennen {date}',
    'upload.beforeDate.other': '{count} kuvaa otettu ennen {date}',
    'upload.afterDate.one': '{count} kuva otettu {date} jälkeen',
    'upload.afterDate.other': '{count} kuvaa otettu {date} jälkeen',
    'upload.povPhotosShownFirst': 'POV-kameralla otetut kuvat näytetään galleriassa ensin',
    'age.addBirthday': 'Vahvista syntymäpäiväsi',
    'age.allowHostRepost': 'Salli {host} repostata tämän päivän kuvat',
    'age.termsAndConditions': 'Vahvistamalla syntymäpäiväsi hyväksyt käyttöehtomme →',
    'time.today': 'tänään',
    'time.yesterday': 'eilen'
  },
  da: {
    'common.loading': 'Indlæser...',
    'common.no': 'Nej',
    'common.yes': 'Ja',
    'common.confirm': 'Bekræft',
    'common.skip': 'Spring over',
    'common.share': 'Del',
    'common.logOut': 'Log ud',
    'common.username': 'Brugernavn',
    'common.tryAgain': 'Prøv igen',
    'upload.addShots': 'Tilføj billeder',
    'upload.noShotsRemaining': 'Ingen billeder tilbage',
    'upload.confirmSubmitTitle': 'Er du sikker på, at du vil indsende?',
    'upload.screenshotIncluded.one': '{count} skærmbillede inkluderet',
    'upload.screenshotIncluded.other': '{count} skærmbilleder inkluderet',
    'upload.noDate.one': '{count} foto har ingen dato',
    'upload.noDate.other': '{count} billeder har ingen dato',
    'upload.beforeDate.one': '{count} foto blev taget før {date}',
    'upload.beforeDate.other': '{count} billeder blev taget før {date}',
    'upload.afterDate.one': '{count} foto blev taget efter {date}',
    'upload.afterDate.other': '{count} billeder blev taget efter {date}',
    'upload.povPhotosShownFirst': 'Billeder taget med POV-kameraet vises først i galleriet',
    'age.addBirthday': 'Bekræft din fødselsdag',
    'age.allowHostRepost': 'Lad {host} reposte dagens billeder',
    'age.termsAndConditions': 'Ved at bekræfte din fødselsdato accepterer du vores vilkår og betingelser →',
    'time.today': 'i dag',
    'time.yesterday': 'i går'
  },
  it: {
    'common.loading': 'Caricamento...',
    'common.no': 'No',
    'common.yes': 'Sì',
    'common.confirm': 'Conferma',
    'common.skip': 'Salta',
    'common.share': 'Condividi',
    'common.logOut': 'Esci',
    'common.username': 'Nome utente',
    'common.tryAgain': 'Riprova',
    'upload.addShots': 'Aggiungi scatti',
    'upload.noShotsRemaining': 'Nessuno scatto rimanente',
    'upload.confirmSubmitTitle': 'Sei sicuro di voler inviare?',
    'upload.screenshotIncluded.one': '{count} screenshot incluso',
    'upload.screenshotIncluded.other': '{count} screenshot inclusi',
    'upload.noDate.one': '{count} foto non ha una data',
    'upload.noDate.other': '{count} foto non hanno una data',
    'upload.beforeDate.one': '{count} foto è stata scattata prima di {date}',
    'upload.beforeDate.other': '{count} foto sono state scattate prima di {date}',
    'upload.afterDate.one': '{count} foto è stata scattata dopo {date}',
    'upload.afterDate.other': '{count} foto sono state scattate dopo {date}',
    'upload.povPhotosShownFirst': 'Le foto scattate con la fotocamera POV sono mostrate per prime nella galleria',
    'age.addBirthday': 'Verifica la tua data di nascita',
    'age.allowHostRepost': 'Consenti a {host} di repostare foto oggi',
    'age.termsAndConditions': 'Confermando la data di nascita, accetti i nostri Termini e Condizioni →',
    'time.today': 'oggi',
    'time.yesterday': 'ieri'
  }
};

const MANUAL_TRANSLATIONS = {
  es: {
    'common.signingOut': 'Cerrando sesión...',
    'common.errorLoadingEvent': 'Error al cargar el evento',
    'common.loadingEvent': 'Cargando evento...',
    'common.switchAccounts': 'Cambiar de cuenta',
    'common.month': 'Mes',
    'common.day': 'Día',
    'common.year': 'Año',
    'common.errorCode': 'Código de error:',
    'auth.signInToUploadPhotos': 'Inicia sesión para subir fotos',
    'auth.continueWithGoogle': 'Continuar con Google',
    'auth.openDefaultBrowserForGoogle': 'Abre tu navegador predeterminado para iniciar sesión con Google',
    'auth.allSignInMethodsFailed': 'Fallaron todos los métodos de inicio de sesión',
    'auth.networkError': 'Error de red. Verifica tu conexión',
    'auth.tooManySignInAttempts': 'Demasiados intentos de inicio de sesión. Inténtalo más tarde',
    'auth.accountDisabled': 'Esta cuenta ha sido deshabilitada',
    'auth.signInFailed': 'Error al iniciar sesión. Inténtalo de nuevo',
    'invalid.noEventFound': 'No se encontró el evento',
    'invalid.eventNotFound': 'Evento no encontrado',
    'invalid.tryDifferentLink': 'Prueba con otro enlace',
    'invalid.invalidPovUrl': 'URL de POV no válida',
    'invalid.inputCannotBeEmpty': 'El campo no puede estar vacío.',
    'invalid.enterPovEventUrl': 'Ingresa enlace POV',
    'upload.hostDisabledUploads': 'El anfitrión desactivó las subidas del carrete',
    'upload.oneShotRemaining': '1 toma restante',
    'upload.shotsRemaining': '{count} tomas restantes',
    'upload.addMoreShots': 'Agregar más tomas',
    'upload.uploadingPhotos': 'Subiendo fotos...',
    'upload.processingPhotos': 'Procesando {current} de {total} fotos',
    'upload.progressPhotosUploaded': '{current} de {total} fotos subidas',
    'upload.uploadedSummary': '{successful} de {total} imágenes subidas',
    'upload.noValidPhotos': 'No hay fotos válidas para subir. Intenta de nuevo con otras fotos.',
    'upload.duplicatePhoto': 'Intentaste agregar una foto que ya subiste',
    'upload.duplicatePhotos': 'Intentaste agregar fotos que ya subiste',
    'upload.screenshotsNotAllowed': 'No se permiten capturas de pantalla',
    'upload.photoTakenBeforeEventStart': 'Se tomó una foto antes de la fecha de inicio del evento. Subidas {validRange}',
    'upload.photosTakenBeforeDate': 'Se tomaron {count} fotos antes de {date}. Subidas {validRange}',
    'upload.photoTakenAfterEventEnd': 'Se tomó una foto después de la fecha de finalización del evento. Subidas {validRange}',
    'upload.photosTakenAfterDate': 'Se tomaron {count} fotos después de {date}. Subidas {validRange}',
    'upload.invalidTypePhoto': 'Una foto no es .PNG, .JPG o .HEIC. {hint}',
    'upload.invalidTypePhotos': '{count} fotos no son .PNG, .JPG o .HEIC. {hint}',
    'upload.photoNoDate': 'Una foto no tiene fecha. {hint}',
    'upload.photosNoDate': '{count} fotos no tienen fecha. {hint}',
    'upload.tooManyPhotosSelected': 'Seleccionaste demasiadas fotos. {hint}',
    'upload.hint.deleteSomeFirst': 'Para agregar más subidas, elimina algunas primero.',
    'upload.hint.selectBestPhoto': '¡Elige tu mejor foto!',
    'upload.hint.selectBestPhotos': '¡Elige tus mejores {count} fotos!',
    'upload.hint.rangeBetween': '{countLabel} tomadas entre {start} y {end} serán aceptadas',
    'upload.hint.rangeAfter': '{countLabel} tomadas después de {start} serán aceptadas',
    'upload.rangeBetweenAccepted': 'tomadas entre {start} y {end} serán aceptadas',
    'upload.rangeAfterAccepted': 'tomadas después de {start} serán aceptadas',
    'upload.onePhoto': '1 foto',
    'upload.upToPhotos': 'Hasta {count} fotos',
    'upload.selectBestPhoto': '¡Elige tu mejor foto!',
    'upload.selectBestPhotos': '¡Elige tus mejores {count} fotos!',
    'upload.willBeAccepted': 'serán aceptadas',
    'upload.takenBetweenAccepted': '{prefix} tomadas entre {start} y {end} serán aceptadas',
    'upload.takenAfterAccepted': '{prefix} tomadas después de {start} serán aceptadas',
    'upload.errorInImage': 'Error en la imagen {index}: {message}',
    'upload.usedAllShotsTap': 'Ya usaste todas tus tomas del carrete. Toca una si cambias de opinión',
    'upload.usedAllShotsDelete': 'Ya usaste todas tus tomas del carrete. Elimina una si cambias de opinión',
    'upload.successUploadedOne': '¡Foto subida correctamente! Te quedan {remaining}',
    'upload.successUploadedMany': '¡{count} fotos subidas correctamente! Te quedan {remaining}',
    'upload.moreErrors.one': '+1 error más',
    'upload.moreErrors.other': '+{count} errores más',
    'age.addBirthday': 'Agregar cumpleaños',
    'age.underAgeMessage': 'Lo sentimos, debes tener {age} años o más para participar en este evento. Descarga la app para crear tu propio evento.',
    'age.selectValidDob': 'Selecciona una fecha de nacimiento válida',
    'age.selectValidMonth': 'Selecciona un mes válido',
    'age.selectValidDate': 'Selecciona una fecha válida',
    'age.failedUpdateDob': 'No se pudo actualizar tu fecha de nacimiento. Inténtalo de nuevo.',
    'age.goBackValidDob': 'Vuelve atrás y selecciona una fecha de nacimiento válida',
    'age.shareInstagramUsername': 'Comparte tu usuario de Instagram',
    'age.theHost': 'el anfitrión',
    'age.allowHostRepost': 'Permite que {host} vuelva a publicar tomas de hoy',
    'age.iosApp': 'App iOS',
    'age.androidApp': 'App Android',
    'time.at': 'a las'
  },
  de: {
    'common.signingOut': 'Abmelden...',
    'common.errorLoadingEvent': 'Fehler beim Laden des Events',
    'common.loadingEvent': 'Event wird geladen...',
    'common.switchAccounts': 'Konto wechseln',
    'common.month': 'Monat',
    'common.day': 'Tag',
    'common.year': 'Jahr',
    'common.errorCode': 'Fehlercode:',
    'auth.signInToUploadPhotos': 'Anmelden, um Fotos hochzuladen',
    'auth.continueWithGoogle': 'Mit Google fortfahren',
    'invalid.noEventFound': 'Kein Event gefunden',
    'invalid.eventNotFound': 'Event nicht gefunden',
    'invalid.tryDifferentLink': 'Anderen Link versuchen',
    'invalid.invalidPovUrl': 'Ungültige POV-URL',
    'invalid.enterPovEventUrl': 'POV-Link eingeben',
    'upload.hostDisabledUploads': 'Host hat Kamera-Uploads deaktiviert',
    'upload.oneShotRemaining': '1 Aufnahme verbleibend',
    'upload.shotsRemaining': '{count} Aufnahmen verbleibend',
    'upload.addMoreShots': 'Mehr Aufnahmen hinzufügen',
    'upload.uploadingPhotos': 'Fotos werden hochgeladen...',
    'age.shareInstagramUsername': 'Teile deinen Instagram-Benutzernamen',
    'age.theHost': 'der Gastgeber',
    'age.iosApp': 'iOS-App',
    'age.androidApp': 'Android-App',
    'time.at': 'um'
  },
  nl: {
    'common.signingOut': 'Uitloggen...',
    'common.errorLoadingEvent': 'Fout bij laden van event',
    'common.loadingEvent': 'Event laden...',
    'common.switchAccounts': 'Van account wisselen',
    'common.month': 'Maand',
    'common.day': 'Dag',
    'common.year': 'Jaar',
    'common.errorCode': 'Foutcode:',
    'auth.signInToUploadPhotos': "Log in om foto's te uploaden",
    'auth.continueWithGoogle': 'Doorgaan met Google',
    'invalid.noEventFound': 'Geen event gevonden',
    'invalid.eventNotFound': 'Event niet gevonden',
    'invalid.tryDifferentLink': 'Probeer een andere link',
    'invalid.invalidPovUrl': 'Ongeldige POV-URL',
    'invalid.enterPovEventUrl': 'Voer POV-link in',
    'upload.hostDisabledUploads': 'Host heeft camera-roll uploads uitgeschakeld',
    'upload.oneShotRemaining': 'Nog 1 foto over',
    'upload.shotsRemaining': 'Nog {count} foto\'s over',
    'upload.addMoreShots': 'Meer foto\'s toevoegen',
    'upload.uploadingPhotos': 'Foto\'s uploaden...',
    'age.shareInstagramUsername': 'Deel je Instagram-gebruikersnaam',
    'age.theHost': 'de host',
    'age.iosApp': 'iOS-app',
    'age.androidApp': 'Android-app',
    'time.at': 'om'
  },
  pt: {
    'common.signingOut': 'Saindo...',
    'common.errorLoadingEvent': 'Erro ao carregar o evento',
    'common.loadingEvent': 'Carregando evento...',
    'common.switchAccounts': 'Trocar de conta',
    'common.month': 'Mês',
    'common.day': 'Dia',
    'common.year': 'Ano',
    'common.errorCode': 'Código de erro:',
    'auth.signInToUploadPhotos': 'Entrar para enviar fotos',
    'auth.continueWithGoogle': 'Continuar com Google',
    'invalid.noEventFound': 'Nenhum evento encontrado',
    'invalid.eventNotFound': 'Evento não encontrado',
    'invalid.tryDifferentLink': 'Tente outro link',
    'invalid.invalidPovUrl': 'URL POV inválida',
    'invalid.enterPovEventUrl': 'Digite link POV',
    'upload.hostDisabledUploads': 'O anfitrião desativou uploads da galeria',
    'upload.oneShotRemaining': '1 foto restante',
    'upload.shotsRemaining': '{count} fotos restantes',
    'upload.addMoreShots': 'Adicionar mais fotos',
    'upload.uploadingPhotos': 'Enviando fotos...',
    'age.shareInstagramUsername': 'Compartilhe seu nome de usuário do Instagram',
    'age.theHost': 'o anfitrião',
    'age.iosApp': 'App iOS',
    'age.androidApp': 'App Android',
    'time.at': 'às'
  },
  fr: {
    'common.signingOut': 'Déconnexion...',
    'common.errorLoadingEvent': 'Erreur lors du chargement de l\'événement',
    'common.loadingEvent': 'Chargement de l\'événement...',
    'common.switchAccounts': 'Changer de compte',
    'common.month': 'Mois',
    'common.day': 'Jour',
    'common.year': 'Année',
    'common.errorCode': 'Code d\'erreur :',
    'auth.signInToUploadPhotos': 'Connectez-vous pour envoyer des photos',
    'auth.continueWithGoogle': 'Continuer avec Google',
    'invalid.noEventFound': 'Aucun événement trouvé',
    'invalid.eventNotFound': 'Événement introuvable',
    'invalid.tryDifferentLink': 'Essayez un autre lien',
    'invalid.invalidPovUrl': 'URL POV invalide',
    'invalid.enterPovEventUrl': 'Entrez le lien POV',
    'upload.hostDisabledUploads': 'L\'hôte a désactivé les uploads de galerie',
    'upload.oneShotRemaining': '1 photo restante',
    'upload.shotsRemaining': '{count} photos restantes',
    'upload.addMoreShots': 'Ajouter plus de photos',
    'upload.uploadingPhotos': 'Envoi des photos...',
    'age.shareInstagramUsername': 'Partagez votre identifiant Instagram',
    'age.theHost': 'l\'hôte',
    'age.iosApp': 'App iOS',
    'age.androidApp': 'App Android',
    'time.at': 'à'
  },
  nb: {
    'common.signingOut': 'Logger ut...',
    'common.errorLoadingEvent': 'Feil ved lasting av arrangement',
    'common.loadingEvent': 'Laster arrangement...',
    'common.switchAccounts': 'Bytt konto',
    'common.month': 'Måned',
    'common.day': 'Dag',
    'common.year': 'År',
    'common.errorCode': 'Feilkode:',
    'auth.signInToUploadPhotos': 'Logg inn for å laste opp bilder',
    'auth.continueWithGoogle': 'Fortsett med Google',
    'invalid.noEventFound': 'Ingen arrangement funnet',
    'invalid.eventNotFound': 'Arrangement ikke funnet',
    'invalid.tryDifferentLink': 'Prøv en annen lenke',
    'invalid.invalidPovUrl': 'Ugyldig POV-URL',
    'invalid.enterPovEventUrl': 'Skriv inn POV-lenke',
    'upload.hostDisabledUploads': 'Verten har deaktivert opplasting fra kamerarull',
    'upload.oneShotRemaining': '1 bilde igjen',
    'upload.shotsRemaining': '{count} bilder igjen',
    'upload.addMoreShots': 'Legg til flere bilder',
    'upload.uploadingPhotos': 'Laster opp bilder...',
    'age.shareInstagramUsername': 'Del Instagram-brukernavnet ditt',
    'age.theHost': 'verten',
    'age.iosApp': 'iOS-app',
    'age.androidApp': 'Android-app',
    'time.at': 'kl.'
  },
  sv: {
    'common.signingOut': 'Loggar ut...',
    'common.errorLoadingEvent': 'Fel vid inläsning av event',
    'common.loadingEvent': 'Laddar event...',
    'common.switchAccounts': 'Byt konto',
    'common.month': 'Månad',
    'common.day': 'Dag',
    'common.year': 'År',
    'common.errorCode': 'Felkod:',
    'auth.signInToUploadPhotos': 'Logga in för att dela foton',
    'auth.continueWithGoogle': 'Fortsätt med Google',
    'invalid.noEventFound': 'Inget event hittades',
    'invalid.eventNotFound': 'Event hittades inte',
    'invalid.tryDifferentLink': 'Prova en annan länk',
    'invalid.invalidPovUrl': 'Ogiltig POV-URL',
    'invalid.enterPovEventUrl': 'Ange POV-länk',
    'upload.hostDisabledUploads': 'Värden har stängt av kamerarulle-uppladdningar',
    'upload.oneShotRemaining': '1 bild kvar',
    'upload.shotsRemaining': '{count} bilder kvar',
    'upload.addMoreShots': 'Lägg till fler bilder',
    'upload.uploadingPhotos': 'Laddar upp bilder...',
    'age.shareInstagramUsername': 'Dela ditt Instagram-användarnamn',
    'age.theHost': 'värden',
    'age.iosApp': 'iOS-app',
    'age.androidApp': 'Android-app',
    'time.at': 'kl.'
  },
  fi: {
    'common.signingOut': 'Kirjaudutaan ulos...',
    'common.errorLoadingEvent': 'Virhe tapahtuman lataamisessa',
    'common.loadingEvent': 'Ladataan tapahtumaa...',
    'common.switchAccounts': 'Vaihda tiliä',
    'common.month': 'Kuukausi',
    'common.day': 'Päivä',
    'common.year': 'Vuosi',
    'common.errorCode': 'Virhekoodi:',
    'auth.signInToUploadPhotos': 'Kirjaudu sisään ladataksesi kuvia',
    'auth.continueWithGoogle': 'Jatka Googlella',
    'invalid.noEventFound': 'Tapahtumaa ei löytynyt',
    'invalid.eventNotFound': 'Tapahtumaa ei löydy',
    'invalid.tryDifferentLink': 'Kokeile toista linkkiä',
    'invalid.invalidPovUrl': 'Virheellinen POV-URL',
    'invalid.enterPovEventUrl': 'Anna POV-linkki',
    'upload.hostDisabledUploads': 'Järjestäjä poisti kamerarullalataukset käytöstä',
    'upload.oneShotRemaining': '1 kuva jäljellä',
    'upload.shotsRemaining': '{count} kuvaa jäljellä',
    'upload.addMoreShots': 'Lisää kuvia',
    'upload.uploadingPhotos': 'Ladataan kuvia...',
    'age.shareInstagramUsername': 'Jaa Instagram-käyttäjänimesi',
    'age.theHost': 'järjestäjä',
    'age.iosApp': 'iOS-sovellus',
    'age.androidApp': 'Android-sovellus',
    'time.at': 'klo'
  },
  da: {
    'common.signingOut': 'Logger ud...',
    'common.errorLoadingEvent': 'Fejl ved indlæsning af event',
    'common.loadingEvent': 'Indlæser event...',
    'common.switchAccounts': 'Skift konto',
    'common.month': 'Måned',
    'common.day': 'Dag',
    'common.year': 'År',
    'common.errorCode': 'Fejlkode:',
    'auth.signInToUploadPhotos': 'Log ind for at uploade billeder',
    'auth.continueWithGoogle': 'Fortsæt med Google',
    'invalid.noEventFound': 'Intet event fundet',
    'invalid.eventNotFound': 'Event blev ikke fundet',
    'invalid.tryDifferentLink': 'Prøv et andet link',
    'invalid.invalidPovUrl': 'Ugyldig POV-URL',
    'invalid.enterPovEventUrl': 'Indtast POV-link',
    'upload.hostDisabledUploads': 'Værten har deaktiveret kamerarulleuploads',
    'upload.oneShotRemaining': '1 billede tilbage',
    'upload.shotsRemaining': '{count} billeder tilbage',
    'upload.addMoreShots': 'Tilføj flere billeder',
    'upload.uploadingPhotos': 'Uploader billeder...',
    'age.shareInstagramUsername': 'Del dit Instagram-brugernavn',
    'age.theHost': 'værten',
    'age.iosApp': 'iOS-app',
    'age.androidApp': 'Android-app',
    'time.at': 'kl.'
  },
  it: {
    'common.signingOut': 'Disconnessione...',
    'common.errorLoadingEvent': 'Errore nel caricamento dell\'evento',
    'common.loadingEvent': 'Caricamento evento...',
    'common.switchAccounts': 'Cambia account',
    'common.month': 'Mese',
    'common.day': 'Giorno',
    'common.year': 'Anno',
    'common.errorCode': 'Codice errore:',
    'auth.signInToUploadPhotos': 'Accedi per caricare foto',
    'auth.continueWithGoogle': 'Continua con Google',
    'invalid.noEventFound': 'Nessun evento trovato',
    'invalid.eventNotFound': 'Evento non trovato',
    'invalid.tryDifferentLink': 'Prova un link diverso',
    'invalid.invalidPovUrl': 'URL POV non valida',
    'invalid.enterPovEventUrl': 'Inserisci link POV',
    'upload.hostDisabledUploads': 'L\'host ha disattivato gli upload dal rullino',
    'upload.oneShotRemaining': '1 scatto rimanente',
    'upload.shotsRemaining': '{count} scatti rimanenti',
    'upload.addMoreShots': 'Aggiungi altri scatti',
    'upload.uploadingPhotos': 'Caricamento foto...',
    'age.shareInstagramUsername': 'Condividi il tuo nome utente Instagram',
    'age.theHost': 'l\'host',
    'age.iosApp': 'App iOS',
    'age.androidApp': 'App Android',
    'time.at': 'alle'
  }
};

const WEB_MISSING_TRANSLATIONS = {
  es: {
    'common.continueWithGoogleAlt': 'Continuar con Google',
    'common.eventNotFoundAlt': 'Evento no encontrado',
    'common.noUploadsAllowedAlt': 'No se permiten subidas',
    'common.pageTitleUploadPhotos': 'Subir Fotos',
    'common.profileAlt': 'Perfil',
    'common.povLogoAlt': 'Logotipo de POV',
    'common.submitAlt': 'Enviar',
    'common.warningAlt': 'Advertencia'
  },
  de: {
    'age.failedUpdateDob': 'Dein Geburtsdatum konnte nicht aktualisiert werden. Bitte versuche es erneut.',
    'age.goBackValidDob': 'Bitte gehe zurück und wähle ein gültiges Geburtsdatum',
    'age.selectValidDate': 'Bitte wähle ein gültiges Datum',
    'age.selectValidDob': 'Bitte wähle ein gültiges Geburtsdatum',
    'age.selectValidMonth': 'Bitte wähle einen gültigen Monat',
    'age.underAgeMessage': 'Sorry, du musst {age} Jahre oder älter sein, um an diesem Event teilzunehmen. Lade die App herunter, um dein eigenes Event zu erstellen.',
    'auth.accountDisabled': 'Dieses Konto wurde deaktiviert',
    'auth.allSignInMethodsFailed': 'Alle Anmeldemethoden sind fehlgeschlagen',
    'auth.networkError': 'Netzwerkfehler. Bitte überprüfe deine Verbindung',
    'auth.openDefaultBrowserForGoogle': 'Bitte öffne deinen Standardbrowser, um dich mit Google anzumelden',
    'auth.signInFailed': 'Anmeldung fehlgeschlagen. Bitte versuche es erneut',
    'auth.tooManySignInAttempts': 'Zu viele Anmeldeversuche. Bitte versuche es später erneut',
    'common.continueWithGoogleAlt': 'Mit Google fortfahren',
    'common.eventNotFoundAlt': 'Event nicht gefunden',
    'common.noUploadsAllowedAlt': 'Keine Uploads erlaubt',
    'common.pageTitleUploadPhotos': 'Fotos Hochladen',
    'common.profileAlt': 'Profil',
    'common.povLogoAlt': 'POV-Logo',
    'common.submitAlt': 'Senden',
    'common.warningAlt': 'Warnung',
    'invalid.inputCannotBeEmpty': 'Eingabe darf nicht leer sein.',
    'upload.duplicatePhoto': 'Du hast versucht, ein Foto hinzuzufügen, das du bereits hochgeladen hast',
    'upload.duplicatePhotos': 'Du hast versucht, Fotos hinzuzufügen, die du bereits hochgeladen hast',
    'upload.errorInImage': 'Fehler in Bild {index}: {message}',
    'upload.hint.deleteSomeFirst': 'Um weitere Uploads hinzuzufügen, lösche zuerst einige.',
    'upload.hint.rangeAfter': '{countLabel}, die nach {start} aufgenommen wurden, werden akzeptiert',
    'upload.hint.rangeBetween': '{countLabel}, die zwischen {start} und {end} aufgenommen wurden, werden akzeptiert',
    'upload.hint.selectBestPhoto': 'Wähle dein bestes Foto aus!',
    'upload.hint.selectBestPhotos': 'Wähle deine besten {count} Fotos aus!',
    'upload.invalidTypePhoto': 'Ein Foto ist keine .PNG-, .JPG- oder .HEIC-Datei. {hint}',
    'upload.invalidTypePhotos': '{count} Fotos sind keine .PNG-, .JPG- oder .HEIC-Dateien. {hint}',
    'upload.moreErrors.one': '+1 weiterer Fehler',
    'upload.moreErrors.other': '+{count} weitere Fehler',
    'upload.noValidPhotos': 'Keine gültigen Fotos zum Hochladen. Bitte versuche es mit anderen Fotos erneut.',
    'upload.onePhoto': '1 Foto',
    'upload.photoNoDate': 'Ein Foto hat kein Datum. {hint}',
    'upload.photoTakenAfterEventEnd': 'Ein Foto wurde nach dem Enddatum des Events aufgenommen. Uploads {validRange}',
    'upload.photoTakenBeforeEventStart': 'Ein Foto wurde vor dem Startdatum des Events aufgenommen. Uploads {validRange}',
    'upload.photosNoDate': '{count} Fotos haben kein Datum. {hint}',
    'upload.photosTakenAfterDate': '{count} Fotos wurden nach {date} aufgenommen. Uploads {validRange}',
    'upload.photosTakenBeforeDate': '{count} Fotos wurden vor {date} aufgenommen. Uploads {validRange}',
    'upload.processingPhotos': 'Verarbeite {current} von {total} Fotos',
    'upload.progressPhotosUploaded': '{current} von {total} Fotos hochgeladen',
    'upload.rangeAfterAccepted': 'die nach {start} aufgenommen wurden, werden akzeptiert',
    'upload.rangeBetweenAccepted': 'die zwischen {start} und {end} aufgenommen wurden, werden akzeptiert',
    'upload.selectBestPhoto': 'Wähle dein bestes Foto aus!',
    'upload.selectBestPhotos': 'Wähle deine besten {count} Fotos aus!',
    'upload.screenshotsNotAllowed': 'Screenshots sind nicht erlaubt',
    'upload.takenAfterAccepted': '{prefix}, die nach {start} aufgenommen wurden, werden akzeptiert',
    'upload.takenBetweenAccepted': '{prefix}, die zwischen {start} und {end} aufgenommen wurden, werden akzeptiert',
    'upload.successUploadedMany': '{count} Fotos erfolgreich hochgeladen! Du hast noch {remaining}',
    'upload.successUploadedOne': 'Foto erfolgreich hochgeladen! Du hast noch {remaining}',
    'upload.tooManyPhotosSelected': 'Zu viele Fotos ausgewählt. {hint}',
    'upload.upToPhotos': 'Bis zu {count} Fotos',
    'upload.uploadedSummary': '{successful} von {total} Bildern hochgeladen!',
    'upload.usedAllShotsDelete': 'Du hast alle deine Kamera-Uploads verwendet! Lösche eins, wenn du es dir anders überlegst',
    'upload.usedAllShotsTap': 'Du hast alle deine Kamera-Uploads verwendet! Tippe auf eins, wenn du es dir anders überlegst',
    'upload.willBeAccepted': 'werden akzeptiert'
  },
  nl: {
    'age.failedUpdateDob': 'Je geboortedatum kon niet worden bijgewerkt. Probeer het opnieuw.',
    'age.goBackValidDob': 'Ga terug en selecteer een geldige geboortedatum',
    'age.selectValidDate': 'Selecteer een geldige datum',
    'age.selectValidDob': 'Selecteer een geldige geboortedatum',
    'age.selectValidMonth': 'Selecteer een geldige maand',
    'age.underAgeMessage': 'Sorry, je moet {age} jaar of ouder zijn om aan dit evenement deel te nemen. Download de app om je eigen evenement te maken.',
    'auth.accountDisabled': 'Dit account is uitgeschakeld',
    'auth.allSignInMethodsFailed': 'Alle inlogmethoden zijn mislukt',
    'auth.networkError': 'Netwerkfout. Controleer je verbinding',
    'auth.openDefaultBrowserForGoogle': 'Open je standaardbrowser om in te loggen met Google',
    'auth.signInFailed': 'Inloggen mislukt. Probeer het opnieuw',
    'auth.tooManySignInAttempts': 'Te veel inlogpogingen. Probeer het later opnieuw',
    'common.continueWithGoogleAlt': 'Doorgaan met Google',
    'common.eventNotFoundAlt': 'Evenement niet gevonden',
    'common.noUploadsAllowedAlt': 'Geen uploads toegestaan',
    'common.pageTitleUploadPhotos': 'Foto\'s Uploaden',
    'common.profileAlt': 'Profiel',
    'common.povLogoAlt': 'POV-logo',
    'common.submitAlt': 'Verzenden',
    'common.warningAlt': 'Waarschuwing',
    'invalid.inputCannotBeEmpty': 'Invoer mag niet leeg zijn.',
    'upload.duplicatePhoto': "Je probeerde een foto toe te voegen die je al hebt geüpload",
    'upload.duplicatePhotos': "Je probeerde foto's toe te voegen die je al hebt geüpload",
    'upload.errorInImage': 'Fout in afbeelding {index}: {message}',
    'upload.hint.deleteSomeFirst': 'Verwijder eerst een paar uploads om meer te kunnen toevoegen.',
    'upload.hint.rangeAfter': '{countLabel} die na {start} zijn genomen, worden geaccepteerd',
    'upload.hint.rangeBetween': '{countLabel} die tussen {start} en {end} zijn genomen, worden geaccepteerd',
    'upload.hint.selectBestPhoto': 'Kies je beste foto!',
    'upload.hint.selectBestPhotos': "Kies je beste {count} foto's!",
    'upload.invalidTypePhoto': 'Een foto is geen .PNG-, .JPG- of .HEIC-bestand. {hint}',
    'upload.invalidTypePhotos': "{count} foto's zijn geen .PNG-, .JPG- of .HEIC-bestanden. {hint}",
    'upload.moreErrors.one': '+1 extra fout',
    'upload.moreErrors.other': '+{count} extra fouten',
    'upload.noValidPhotos': "Geen geldige foto's om te uploaden. Probeer het opnieuw met andere foto's.",
    'upload.onePhoto': '1 foto',
    'upload.photoNoDate': 'Een foto heeft geen datum. {hint}',
    'upload.photoTakenAfterEventEnd': 'Een foto is na de einddatum van het evenement genomen. Uploads {validRange}',
    'upload.photoTakenBeforeEventStart': 'Een foto is vóór de startdatum van het evenement genomen. Uploads {validRange}',
    'upload.photosNoDate': "{count} foto's hebben geen datum. {hint}",
    'upload.photosTakenAfterDate': "{count} foto's zijn na {date} genomen. Uploads {validRange}",
    'upload.photosTakenBeforeDate': "{count} foto's zijn vóór {date} genomen. Uploads {validRange}",
    'upload.processingPhotos': "Bezig met verwerken van {current} van {total} foto's",
    'upload.progressPhotosUploaded': "{current} van {total} foto's geüpload",
    'upload.rangeAfterAccepted': 'genomen na {start} worden geaccepteerd',
    'upload.rangeBetweenAccepted': 'genomen tussen {start} en {end} worden geaccepteerd',
    'upload.selectBestPhoto': 'Kies je beste foto!',
    'upload.selectBestPhotos': "Kies je beste {count} foto's!",
    'upload.screenshotsNotAllowed': 'Screenshots zijn niet toegestaan',
    'upload.takenAfterAccepted': '{prefix} genomen na {start} worden geaccepteerd',
    'upload.takenBetweenAccepted': '{prefix} genomen tussen {start} en {end} worden geaccepteerd',
    'upload.successUploadedMany': "{count} foto's succesvol geüpload! Je hebt nog {remaining}",
    'upload.successUploadedOne': 'Foto succesvol geüpload! Je hebt nog {remaining}',
    'upload.tooManyPhotosSelected': "Te veel foto's geselecteerd. {hint}",
    'upload.upToPhotos': "Tot {count} foto's",
    'upload.uploadedSummary': '{successful} van {total} afbeeldingen geüpload!',
    'upload.usedAllShotsDelete': 'Je hebt al je camera-roll uploads gebruikt! Verwijder er één als je van gedachten verandert',
    'upload.usedAllShotsTap': 'Je hebt al je camera-roll uploads gebruikt! Tik op een foto als je van gedachten verandert',
    'upload.willBeAccepted': 'worden geaccepteerd'
  },
  pt: {
    'age.failedUpdateDob': 'Falha ao atualizar sua data de nascimento. Tente novamente.',
    'age.goBackValidDob': 'Volte e selecione uma data de nascimento válida',
    'age.selectValidDate': 'Selecione uma data válida',
    'age.selectValidDob': 'Selecione uma data de nascimento válida',
    'age.selectValidMonth': 'Selecione um mês válido',
    'age.underAgeMessage': 'Desculpe, você precisa ter {age} anos ou mais para participar deste evento. Baixe o app para criar seu próprio evento.',
    'auth.accountDisabled': 'Esta conta foi desativada',
    'auth.allSignInMethodsFailed': 'Todos os métodos de login falharam',
    'auth.networkError': 'Erro de rede. Verifique sua conexão',
    'auth.openDefaultBrowserForGoogle': 'Abra seu navegador padrão para entrar com o Google',
    'auth.signInFailed': 'Falha no login. Tente novamente',
    'auth.tooManySignInAttempts': 'Muitas tentativas de login. Tente novamente mais tarde',
    'common.continueWithGoogleAlt': 'Continuar com Google',
    'common.eventNotFoundAlt': 'Evento não encontrado',
    'common.noUploadsAllowedAlt': 'Uploads não permitidos',
    'common.pageTitleUploadPhotos': 'Enviar Fotos',
    'common.profileAlt': 'Perfil',
    'common.povLogoAlt': 'Logotipo do POV',
    'common.submitAlt': 'Enviar',
    'common.warningAlt': 'Aviso',
    'invalid.inputCannotBeEmpty': 'A entrada não pode estar vazia.',
    'upload.duplicatePhoto': 'Você tentou adicionar uma foto que já enviou',
    'upload.duplicatePhotos': 'Você tentou adicionar fotos que já enviou',
    'upload.errorInImage': 'Erro na imagem {index}: {message}',
    'upload.hint.deleteSomeFirst': 'Para adicionar mais uploads, exclua alguns primeiro.',
    'upload.hint.rangeAfter': '{countLabel} tiradas após {start} serão aceitas',
    'upload.hint.rangeBetween': '{countLabel} tiradas entre {start} e {end} serão aceitas',
    'upload.hint.selectBestPhoto': 'Selecione sua melhor foto!',
    'upload.hint.selectBestPhotos': 'Selecione suas melhores {count} fotos!',
    'upload.invalidTypePhoto': 'Uma foto não é .PNG, .JPG ou .HEIC. {hint}',
    'upload.invalidTypePhotos': '{count} fotos não são .PNG, .JPG ou .HEIC. {hint}',
    'upload.moreErrors.one': '+1 erro a mais',
    'upload.moreErrors.other': '+{count} erros a mais',
    'upload.noValidPhotos': 'Nenhuma foto válida para enviar. Tente novamente com outras fotos.',
    'upload.onePhoto': '1 foto',
    'upload.photoNoDate': 'Uma foto não tem data. {hint}',
    'upload.photoTakenAfterEventEnd': 'Uma foto foi tirada após a data de término do evento. Uploads {validRange}',
    'upload.photoTakenBeforeEventStart': 'Uma foto foi tirada antes da data de início do evento. Uploads {validRange}',
    'upload.photosNoDate': '{count} fotos não têm data. {hint}',
    'upload.photosTakenAfterDate': '{count} fotos foram tiradas após {date}. Uploads {validRange}',
    'upload.photosTakenBeforeDate': '{count} fotos foram tiradas antes de {date}. Uploads {validRange}',
    'upload.processingPhotos': 'Processando {current} de {total} fotos',
    'upload.progressPhotosUploaded': '{current} de {total} fotos enviadas',
    'upload.rangeAfterAccepted': 'tiradas após {start} serão aceitas',
    'upload.rangeBetweenAccepted': 'tiradas entre {start} e {end} serão aceitas',
    'upload.selectBestPhoto': 'Selecione sua melhor foto!',
    'upload.selectBestPhotos': 'Selecione suas melhores {count} fotos!',
    'upload.screenshotsNotAllowed': 'Capturas de tela não são permitidas',
    'upload.takenAfterAccepted': '{prefix} tiradas após {start} serão aceitas',
    'upload.takenBetweenAccepted': '{prefix} tiradas entre {start} e {end} serão aceitas',
    'upload.successUploadedMany': '{count} fotos enviadas com sucesso! Você tem {remaining} restantes',
    'upload.successUploadedOne': 'Foto enviada com sucesso! Você tem {remaining} restante(s)',
    'upload.tooManyPhotosSelected': 'Muitas fotos selecionadas. {hint}',
    'upload.upToPhotos': 'Até {count} fotos',
    'upload.uploadedSummary': '{successful} de {total} imagens enviadas!',
    'upload.usedAllShotsDelete': 'Você usou todos os seus uploads do rolo da câmera! Exclua uma se mudar de ideia',
    'upload.usedAllShotsTap': 'Você usou todos os seus uploads do rolo da câmera! Toque em uma se mudar de ideia',
    'upload.willBeAccepted': 'serão aceitas'
  },
  fr: {
    'age.failedUpdateDob': 'Échec de la mise à jour de votre date de naissance. Veuillez réessayer.',
    'age.goBackValidDob': 'Veuillez revenir en arrière et sélectionner une date de naissance valide',
    'age.selectValidDate': 'Veuillez sélectionner une date valide',
    'age.selectValidDob': 'Veuillez sélectionner une date de naissance valide',
    'age.selectValidMonth': 'Veuillez sélectionner un mois valide',
    'age.underAgeMessage': 'Désolé, vous devez avoir {age} ans ou plus pour participer à cet événement. Téléchargez l’app pour créer votre propre événement.',
    'auth.accountDisabled': 'Ce compte a été désactivé',
    'auth.allSignInMethodsFailed': 'Toutes les méthodes de connexion ont échoué',
    'auth.networkError': 'Erreur réseau. Veuillez vérifier votre connexion',
    'auth.openDefaultBrowserForGoogle': 'Veuillez ouvrir votre navigateur par défaut pour vous connecter avec Google',
    'auth.signInFailed': 'Échec de la connexion. Veuillez réessayer',
    'auth.tooManySignInAttempts': 'Trop de tentatives de connexion. Veuillez réessayer plus tard',
    'common.continueWithGoogleAlt': 'Continuer avec Google',
    'common.eventNotFoundAlt': 'Événement introuvable',
    'common.noUploadsAllowedAlt': 'Aucun upload autorisé',
    'common.pageTitleUploadPhotos': 'Ajouter Photos',
    'common.profileAlt': 'Profil',
    'common.povLogoAlt': 'Logo POV',
    'common.submitAlt': 'Envoyer',
    'common.warningAlt': 'Avertissement',
    'invalid.inputCannotBeEmpty': 'La saisie ne peut pas être vide.',
    'upload.duplicatePhoto': 'Vous avez essayé d’ajouter une photo que vous avez déjà envoyée',
    'upload.duplicatePhotos': 'Vous avez essayé d’ajouter des photos que vous avez déjà envoyées',
    'upload.errorInImage': 'Erreur dans l’image {index} : {message}',
    'upload.hint.deleteSomeFirst': 'Pour ajouter plus d’uploads, supprimez-en d’abord quelques-uns.',
    'upload.hint.rangeAfter': '{countLabel} prises après {start} seront acceptées',
    'upload.hint.rangeBetween': '{countLabel} prises entre {start} et {end} seront acceptées',
    'upload.hint.selectBestPhoto': 'Sélectionnez votre meilleure photo !',
    'upload.hint.selectBestPhotos': 'Sélectionnez vos {count} meilleures photos !',
    'upload.invalidTypePhoto': 'Une photo n’est pas en .PNG, .JPG ou .HEIC. {hint}',
    'upload.invalidTypePhotos': '{count} photos ne sont pas en .PNG, .JPG ou .HEIC. {hint}',
    'upload.moreErrors.one': '+1 erreur de plus',
    'upload.moreErrors.other': '+{count} erreurs de plus',
    'upload.noValidPhotos': 'Aucune photo valide à envoyer. Veuillez réessayer avec d’autres photos.',
    'upload.onePhoto': '1 photo',
    'upload.photoNoDate': 'Une photo n’a pas de date. {hint}',
    'upload.photoTakenAfterEventEnd': 'Une photo a été prise après la date de fin de l’événement. Uploads {validRange}',
    'upload.photoTakenBeforeEventStart': 'Une photo a été prise avant la date de début de l’événement. Uploads {validRange}',
    'upload.photosNoDate': '{count} photos n’ont pas de date. {hint}',
    'upload.photosTakenAfterDate': '{count} photos ont été prises après {date}. Uploads {validRange}',
    'upload.photosTakenBeforeDate': '{count} photos ont été prises avant {date}. Uploads {validRange}',
    'upload.processingPhotos': 'Traitement de {current} sur {total} photos',
    'upload.progressPhotosUploaded': '{current} sur {total} photos envoyées',
    'upload.rangeAfterAccepted': 'prises après {start} seront acceptées',
    'upload.rangeBetweenAccepted': 'prises entre {start} et {end} seront acceptées',
    'upload.selectBestPhoto': 'Sélectionnez votre meilleure photo !',
    'upload.selectBestPhotos': 'Sélectionnez vos {count} meilleures photos !',
    'upload.screenshotsNotAllowed': 'Les captures d’écran ne sont pas autorisées',
    'upload.takenAfterAccepted': '{prefix} prises après {start} seront acceptées',
    'upload.takenBetweenAccepted': '{prefix} prises entre {start} et {end} seront acceptées',
    'upload.successUploadedMany': '{count} photos envoyées avec succès ! Il vous en reste {remaining}',
    'upload.successUploadedOne': 'Photo envoyée avec succès ! Il vous en reste {remaining}',
    'upload.tooManyPhotosSelected': 'Trop de photos sélectionnées. {hint}',
    'upload.upToPhotos': 'Jusqu’à {count} photos',
    'upload.uploadedSummary': '{successful} images envoyées sur {total} !',
    'upload.usedAllShotsDelete': 'Vous avez utilisé tous vos uploads de pellicule ! Supprimez-en une si vous changez d’avis',
    'upload.usedAllShotsTap': 'Vous avez utilisé tous vos uploads de pellicule ! Touchez-en une si vous changez d’avis',
    'upload.willBeAccepted': 'seront acceptées'
  },
  nb: {
    'age.failedUpdateDob': 'Kunne ikke oppdatere fødselsdatoen din. Prøv igjen.',
    'age.goBackValidDob': 'Gå tilbake og velg en gyldig fødselsdato',
    'age.selectValidDate': 'Velg en gyldig dato',
    'age.selectValidDob': 'Velg en gyldig fødselsdato',
    'age.selectValidMonth': 'Velg en gyldig måned',
    'age.underAgeMessage': 'Beklager, du må være {age} år eller eldre for å delta i dette arrangementet. Last ned appen for å opprette ditt eget arrangement.',
    'auth.accountDisabled': 'Denne kontoen er deaktivert',
    'auth.allSignInMethodsFailed': 'Alle innloggingsmetoder mislyktes',
    'auth.networkError': 'Nettverksfeil. Sjekk tilkoblingen din',
    'auth.openDefaultBrowserForGoogle': 'Åpne standardnettleseren din for å logge inn med Google',
    'auth.signInFailed': 'Innlogging mislyktes. Prøv igjen',
    'auth.tooManySignInAttempts': 'For mange innloggingsforsøk. Prøv igjen senere',
    'common.continueWithGoogleAlt': 'Fortsett med Google',
    'common.eventNotFoundAlt': 'Arrangement ikke funnet',
    'common.noUploadsAllowedAlt': 'Ingen opplastinger tillatt',
    'common.pageTitleUploadPhotos': 'Last Opp Bilder',
    'common.profileAlt': 'Profil',
    'common.povLogoAlt': 'POV-logo',
    'common.submitAlt': 'Send inn',
    'common.warningAlt': 'Advarsel',
    'invalid.inputCannotBeEmpty': 'Feltet kan ikke være tomt.',
    'upload.duplicatePhoto': 'Du prøvde å legge til et bilde du allerede har lastet opp',
    'upload.duplicatePhotos': 'Du prøvde å legge til bilder du allerede har lastet opp',
    'upload.errorInImage': 'Feil i bilde {index}: {message}',
    'upload.hint.deleteSomeFirst': 'For å legge til flere opplastinger må du først slette noen.',
    'upload.hint.rangeAfter': '{countLabel} tatt etter {start} blir godkjent',
    'upload.hint.rangeBetween': '{countLabel} tatt mellom {start} og {end} blir godkjent',
    'upload.hint.selectBestPhoto': 'Velg ditt beste bilde!',
    'upload.hint.selectBestPhotos': 'Velg dine beste {count} bilder!',
    'upload.invalidTypePhoto': 'Et bilde er ikke .PNG, .JPG eller .HEIC. {hint}',
    'upload.invalidTypePhotos': '{count} bilder er ikke .PNG, .JPG eller .HEIC. {hint}',
    'upload.moreErrors.one': '+1 feil til',
    'upload.moreErrors.other': '+{count} feil til',
    'upload.noValidPhotos': 'Ingen gyldige bilder å laste opp. Prøv igjen med andre bilder.',
    'upload.onePhoto': '1 bilde',
    'upload.photoNoDate': 'Et bilde har ikke dato. {hint}',
    'upload.photoTakenAfterEventEnd': 'Et bilde ble tatt etter sluttdatoen for arrangementet. Opplastinger {validRange}',
    'upload.photoTakenBeforeEventStart': 'Et bilde ble tatt før startdatoen for arrangementet. Opplastinger {validRange}',
    'upload.photosNoDate': '{count} bilder har ikke dato. {hint}',
    'upload.photosTakenAfterDate': '{count} bilder ble tatt etter {date}. Opplastinger {validRange}',
    'upload.photosTakenBeforeDate': '{count} bilder ble tatt før {date}. Opplastinger {validRange}',
    'upload.processingPhotos': 'Behandler {current} av {total} bilder',
    'upload.progressPhotosUploaded': '{current} av {total} bilder lastet opp',
    'upload.rangeAfterAccepted': 'tatt etter {start} blir godkjent',
    'upload.rangeBetweenAccepted': 'tatt mellom {start} og {end} blir godkjent',
    'upload.selectBestPhoto': 'Velg ditt beste bilde!',
    'upload.selectBestPhotos': 'Velg dine beste {count} bilder!',
    'upload.screenshotsNotAllowed': 'Skjermbilder er ikke tillatt',
    'upload.takenAfterAccepted': '{prefix} tatt etter {start} blir godkjent',
    'upload.takenBetweenAccepted': '{prefix} tatt mellom {start} og {end} blir godkjent',
    'upload.successUploadedMany': '{count} bilder lastet opp! Du har {remaining} igjen',
    'upload.successUploadedOne': 'Bildet ble lastet opp! Du har {remaining} igjen',
    'upload.tooManyPhotosSelected': 'For mange bilder valgt. {hint}',
    'upload.upToPhotos': 'Opptil {count} bilder',
    'upload.uploadedSummary': 'Lastet opp {successful} av {total} bilder!',
    'upload.usedAllShotsDelete': 'Du har brukt alle kamerarull-opplastingene dine! Slett ett hvis du ombestemmer deg',
    'upload.usedAllShotsTap': 'Du har brukt alle kamerarull-opplastingene dine! Trykk på ett hvis du ombestemmer deg',
    'upload.willBeAccepted': 'blir godkjent'
  },
  sv: {
    'age.failedUpdateDob': 'Det gick inte att uppdatera ditt födelsedatum. Försök igen.',
    'age.goBackValidDob': 'Gå tillbaka och välj ett giltigt födelsedatum',
    'age.selectValidDate': 'Välj ett giltigt datum',
    'age.selectValidDob': 'Välj ett giltigt födelsedatum',
    'age.selectValidMonth': 'Välj en giltig månad',
    'age.underAgeMessage': 'Tyvärr måste du vara {age} år eller äldre för att delta i det här eventet. Ladda ner appen för att skapa ditt eget event.',
    'auth.accountDisabled': 'Det här kontot har inaktiverats',
    'auth.allSignInMethodsFailed': 'Alla inloggningsmetoder misslyckades',
    'auth.networkError': 'Nätverksfel. Kontrollera din anslutning',
    'auth.openDefaultBrowserForGoogle': 'Öppna din standardwebbläsare för att logga in med Google',
    'auth.signInFailed': 'Inloggningen misslyckades. Försök igen',
    'auth.tooManySignInAttempts': 'För många inloggningsförsök. Försök igen senare',
    'common.continueWithGoogleAlt': 'Fortsätt med Google',
    'common.eventNotFoundAlt': 'Event hittades inte',
    'common.noUploadsAllowedAlt': 'Inga uppladdningar tillåtna',
    'common.pageTitleUploadPhotos': 'Ladda Upp Bilder',
    'common.profileAlt': 'Profil',
    'common.povLogoAlt': 'POV-logotyp',
    'common.submitAlt': 'Skicka',
    'common.warningAlt': 'Varning',
    'invalid.inputCannotBeEmpty': 'Inmatningen får inte vara tom.',
    'upload.duplicatePhoto': 'Du försökte lägga till ett foto som du redan har laddat upp',
    'upload.duplicatePhotos': 'Du försökte lägga till foton som du redan har laddat upp',
    'upload.errorInImage': 'Fel i bild {index}: {message}',
    'upload.hint.deleteSomeFirst': 'För att lägga till fler uppladdningar, ta bort några först.',
    'upload.hint.rangeAfter': '{countLabel} tagna efter {start} kommer att accepteras',
    'upload.hint.rangeBetween': '{countLabel} tagna mellan {start} och {end} kommer att accepteras',
    'upload.hint.selectBestPhoto': 'Välj ditt bästa foto!',
    'upload.hint.selectBestPhotos': 'Välj dina bästa {count} foton!',
    'upload.invalidTypePhoto': 'Ett foto är inte .PNG, .JPG eller .HEIC. {hint}',
    'upload.invalidTypePhotos': '{count} foton är inte .PNG, .JPG eller .HEIC. {hint}',
    'upload.moreErrors.one': '+1 fel till',
    'upload.moreErrors.other': '+{count} fel till',
    'upload.noValidPhotos': 'Inga giltiga foton att ladda upp. Försök igen med andra foton.',
    'upload.onePhoto': '1 foto',
    'upload.photoNoDate': 'Ett foto saknar datum. {hint}',
    'upload.photoTakenAfterEventEnd': 'Ett foto togs efter eventets slutdatum. Uppladdningar {validRange}',
    'upload.photoTakenBeforeEventStart': 'Ett foto togs före eventets startdatum. Uppladdningar {validRange}',
    'upload.photosNoDate': '{count} foton saknar datum. {hint}',
    'upload.photosTakenAfterDate': '{count} foton togs efter {date}. Uppladdningar {validRange}',
    'upload.photosTakenBeforeDate': '{count} foton togs före {date}. Uppladdningar {validRange}',
    'upload.processingPhotos': 'Bearbetar {current} av {total} foton',
    'upload.progressPhotosUploaded': '{current} av {total} foton uppladdade',
    'upload.rangeAfterAccepted': 'tagna efter {start} kommer att accepteras',
    'upload.rangeBetweenAccepted': 'tagna mellan {start} och {end} kommer att accepteras',
    'upload.selectBestPhoto': 'Välj ditt bästa foto!',
    'upload.selectBestPhotos': 'Välj dina bästa {count} foton!',
    'upload.screenshotsNotAllowed': 'Skärmbilder är inte tillåtna',
    'upload.takenAfterAccepted': '{prefix} tagna efter {start} kommer att accepteras',
    'upload.takenBetweenAccepted': '{prefix} tagna mellan {start} och {end} kommer att accepteras',
    'upload.successUploadedMany': '{count} foton uppladdade! Du har {remaining} kvar',
    'upload.successUploadedOne': 'Foto uppladdat! Du har {remaining} kvar',
    'upload.tooManyPhotosSelected': 'För många foton valda. {hint}',
    'upload.upToPhotos': 'Upp till {count} foton',
    'upload.uploadedSummary': 'Laddade upp {successful} av {total} bilder!',
    'upload.usedAllShotsDelete': 'Du har använt alla dina kamerarulle-uppladdningar! Ta bort en om du ändrar dig',
    'upload.usedAllShotsTap': 'Du har använt alla dina kamerarulle-uppladdningar! Tryck på en om du ändrar dig',
    'upload.willBeAccepted': 'kommer att accepteras'
  },
  fi: {
    'age.failedUpdateDob': 'Syntymäpäiväsi päivittäminen epäonnistui. Yritä uudelleen.',
    'age.goBackValidDob': 'Palaa takaisin ja valitse kelvollinen syntymäpäivä',
    'age.selectValidDate': 'Valitse kelvollinen päivämäärä',
    'age.selectValidDob': 'Valitse kelvollinen syntymäpäivä',
    'age.selectValidMonth': 'Valitse kelvollinen kuukausi',
    'age.underAgeMessage': 'Valitettavasti sinun täytyy olla vähintään {age} vuotta osallistuaksesi tähän tapahtumaan. Lataa sovellus luodaksesi oman tapahtumasi.',
    'auth.accountDisabled': 'Tämä tili on poistettu käytöstä',
    'auth.allSignInMethodsFailed': 'Kaikki kirjautumistavat epäonnistuivat',
    'auth.networkError': 'Verkkovirhe. Tarkista yhteytesi',
    'auth.openDefaultBrowserForGoogle': 'Avaa oletusselaimesi kirjautuaksesi Googlella',
    'auth.signInFailed': 'Kirjautuminen epäonnistui. Yritä uudelleen',
    'auth.tooManySignInAttempts': 'Liian monta kirjautumisyritystä. Yritä myöhemmin uudelleen',
    'common.continueWithGoogleAlt': 'Jatka Googlella',
    'common.eventNotFoundAlt': 'Tapahtumaa ei löydy',
    'common.noUploadsAllowedAlt': 'Lataukset eivät ole sallittuja',
    'common.pageTitleUploadPhotos': 'Lataa Kuvat',
    'common.profileAlt': 'Profiili',
    'common.povLogoAlt': 'POV-logo',
    'common.submitAlt': 'Lähetä',
    'common.warningAlt': 'Varoitus',
    'invalid.inputCannotBeEmpty': 'Syöte ei voi olla tyhjä.',
    'upload.duplicatePhoto': 'Yritit lisätä kuvan, jonka olet jo ladannut',
    'upload.duplicatePhotos': 'Yritit lisätä kuvia, jotka olet jo ladannut',
    'upload.errorInImage': 'Virhe kuvassa {index}: {message}',
    'upload.hint.deleteSomeFirst': 'Poista ensin joitakin, jotta voit lisätä lisää latauksia.',
    'upload.hint.rangeAfter': '{countLabel}, jotka on otettu {start} jälkeen, hyväksytään',
    'upload.hint.rangeBetween': '{countLabel}, jotka on otettu välillä {start} ja {end}, hyväksytään',
    'upload.hint.selectBestPhoto': 'Valitse paras kuvasi!',
    'upload.hint.selectBestPhotos': 'Valitse parhaat {count} kuvasi!',
    'upload.invalidTypePhoto': 'Kuva ei ole .PNG-, .JPG- tai .HEIC-muodossa. {hint}',
    'upload.invalidTypePhotos': '{count} kuvaa ei ole .PNG-, .JPG- tai .HEIC-muodossa. {hint}',
    'upload.moreErrors.one': '+1 virhe lisää',
    'upload.moreErrors.other': '+{count} virhettä lisää',
    'upload.noValidPhotos': 'Ei kelvollisia kuvia ladattavaksi. Yritä uudelleen eri kuvilla.',
    'upload.onePhoto': '1 kuva',
    'upload.photoNoDate': 'Kuvalla ei ole päivämäärää. {hint}',
    'upload.photoTakenAfterEventEnd': 'Kuva on otettu tapahtuman päättymispäivän jälkeen. Lataukset {validRange}',
    'upload.photoTakenBeforeEventStart': 'Kuva on otettu ennen tapahtuman alkamispäivää. Lataukset {validRange}',
    'upload.photosNoDate': '{count} kuvalla ei ole päivämäärää. {hint}',
    'upload.photosTakenAfterDate': '{count} kuvaa on otettu {date} jälkeen. Lataukset {validRange}',
    'upload.photosTakenBeforeDate': '{count} kuvaa on otettu ennen {date}. Lataukset {validRange}',
    'upload.processingPhotos': 'Käsitellään {current} / {total} kuvaa',
    'upload.progressPhotosUploaded': '{current} / {total} kuvaa ladattu',
    'upload.rangeAfterAccepted': '{start} jälkeen otetut hyväksytään',
    'upload.rangeBetweenAccepted': 'välillä {start} ja {end} otetut hyväksytään',
    'upload.selectBestPhoto': 'Valitse paras kuvasi!',
    'upload.selectBestPhotos': 'Valitse parhaat {count} kuvasi!',
    'upload.screenshotsNotAllowed': 'Kuvakaappaukset eivät ole sallittuja',
    'upload.takenAfterAccepted': '{prefix}, jotka on otettu {start} jälkeen, hyväksytään',
    'upload.takenBetweenAccepted': '{prefix}, jotka on otettu välillä {start} ja {end}, hyväksytään',
    'upload.successUploadedMany': '{count} kuvaa ladattu onnistuneesti! Sinulla on {remaining} jäljellä',
    'upload.successUploadedOne': 'Kuva ladattu onnistuneesti! Sinulla on {remaining} jäljellä',
    'upload.tooManyPhotosSelected': 'Liian monta kuvaa valittu. {hint}',
    'upload.upToPhotos': 'Enintään {count} kuvaa',
    'upload.uploadedSummary': 'Ladattu {successful} / {total} kuvaa!',
    'upload.usedAllShotsDelete': 'Olet käyttänyt kaikki kamerarullan latauksesi! Poista yksi, jos muutat mielesi',
    'upload.usedAllShotsTap': 'Olet käyttänyt kaikki kamerarullan latauksesi! Napauta yhtä, jos muutat mielesi',
    'upload.willBeAccepted': 'hyväksytään'
  },
  da: {
    'age.failedUpdateDob': 'Kunne ikke opdatere din fødselsdato. Prøv igen.',
    'age.goBackValidDob': 'Gå tilbage og vælg en gyldig fødselsdato',
    'age.selectValidDate': 'Vælg en gyldig dato',
    'age.selectValidDob': 'Vælg en gyldig fødselsdato',
    'age.selectValidMonth': 'Vælg en gyldig måned',
    'age.underAgeMessage': 'Beklager, du skal være {age} år eller ældre for at deltage i denne begivenhed. Download appen for at oprette din egen begivenhed.',
    'auth.accountDisabled': 'Denne konto er deaktiveret',
    'auth.allSignInMethodsFailed': 'Alle loginmetoder mislykkedes',
    'auth.networkError': 'Netværksfejl. Tjek din forbindelse',
    'auth.openDefaultBrowserForGoogle': 'Åbn din standardbrowser for at logge ind med Google',
    'auth.signInFailed': 'Login mislykkedes. Prøv igen',
    'auth.tooManySignInAttempts': 'For mange loginforsøg. Prøv igen senere',
    'common.continueWithGoogleAlt': 'Fortsæt med Google',
    'common.eventNotFoundAlt': 'Event blev ikke fundet',
    'common.noUploadsAllowedAlt': 'Ingen uploads tilladt',
    'common.pageTitleUploadPhotos': 'Upload Billeder',
    'common.profileAlt': 'Profil',
    'common.povLogoAlt': 'POV-logo',
    'common.submitAlt': 'Send',
    'common.warningAlt': 'Advarsel',
    'invalid.inputCannotBeEmpty': 'Input må ikke være tomt.',
    'upload.duplicatePhoto': 'Du prøvede at tilføje et foto, som du allerede har uploadet',
    'upload.duplicatePhotos': 'Du prøvede at tilføje fotos, som du allerede har uploadet',
    'upload.errorInImage': 'Fejl i billede {index}: {message}',
    'upload.hint.deleteSomeFirst': 'For at tilføje flere uploads skal du slette nogle først.',
    'upload.hint.rangeAfter': '{countLabel} taget efter {start} vil blive accepteret',
    'upload.hint.rangeBetween': '{countLabel} taget mellem {start} og {end} vil blive accepteret',
    'upload.hint.selectBestPhoto': 'Vælg dit bedste foto!',
    'upload.hint.selectBestPhotos': 'Vælg dine bedste {count} fotos!',
    'upload.invalidTypePhoto': 'Et foto er ikke .PNG, .JPG eller .HEIC. {hint}',
    'upload.invalidTypePhotos': '{count} fotos er ikke .PNG, .JPG eller .HEIC. {hint}',
    'upload.moreErrors.one': '+1 fejl mere',
    'upload.moreErrors.other': '+{count} fejl mere',
    'upload.noValidPhotos': 'Ingen gyldige fotos at uploade. Prøv igen med andre fotos.',
    'upload.onePhoto': '1 foto',
    'upload.photoNoDate': 'Et foto har ingen dato. {hint}',
    'upload.photoTakenAfterEventEnd': 'Et foto blev taget efter eventets slutdato. Uploads {validRange}',
    'upload.photoTakenBeforeEventStart': 'Et foto blev taget før eventets startdato. Uploads {validRange}',
    'upload.photosNoDate': '{count} fotos har ingen dato. {hint}',
    'upload.photosTakenAfterDate': '{count} fotos blev taget efter {date}. Uploads {validRange}',
    'upload.photosTakenBeforeDate': '{count} fotos blev taget før {date}. Uploads {validRange}',
    'upload.processingPhotos': 'Behandler {current} af {total} fotos',
    'upload.progressPhotosUploaded': '{current} af {total} fotos uploadet',
    'upload.rangeAfterAccepted': 'taget efter {start} vil blive accepteret',
    'upload.rangeBetweenAccepted': 'taget mellem {start} og {end} vil blive accepteret',
    'upload.selectBestPhoto': 'Vælg dit bedste foto!',
    'upload.selectBestPhotos': 'Vælg dine bedste {count} fotos!',
    'upload.screenshotsNotAllowed': 'Skærmbilleder er ikke tilladt',
    'upload.takenAfterAccepted': '{prefix} taget efter {start} vil blive accepteret',
    'upload.takenBetweenAccepted': '{prefix} taget mellem {start} og {end} vil blive accepteret',
    'upload.successUploadedMany': '{count} fotos uploadet! Du har {remaining} tilbage',
    'upload.successUploadedOne': 'Foto uploadet! Du har {remaining} tilbage',
    'upload.tooManyPhotosSelected': 'For mange fotos valgt. {hint}',
    'upload.upToPhotos': 'Op til {count} fotos',
    'upload.uploadedSummary': 'Uploadet {successful} af {total} billeder!',
    'upload.usedAllShotsDelete': 'Du har brugt alle dine kamerarulle-uploads! Slet et, hvis du ombestemmer dig',
    'upload.usedAllShotsTap': 'Du har brugt alle dine kamerarulle-uploads! Tryk på et, hvis du ombestemmer dig',
    'upload.willBeAccepted': 'vil blive accepteret'
  },
  it: {
    'age.failedUpdateDob': 'Impossibile aggiornare la tua data di nascita. Riprova.',
    'age.goBackValidDob': 'Torna indietro e seleziona una data di nascita valida',
    'age.selectValidDate': 'Seleziona una data valida',
    'age.selectValidDob': 'Seleziona una data di nascita valida',
    'age.selectValidMonth': 'Seleziona un mese valido',
    'age.underAgeMessage': 'Spiacente, devi avere almeno {age} anni per partecipare a questo evento. Scarica l’app per creare il tuo evento.',
    'auth.accountDisabled': 'Questo account è stato disabilitato',
    'auth.allSignInMethodsFailed': 'Tutti i metodi di accesso non sono riusciti',
    'auth.networkError': 'Errore di rete. Controlla la connessione',
    'auth.openDefaultBrowserForGoogle': 'Apri il browser predefinito per accedere con Google',
    'auth.signInFailed': 'Accesso non riuscito. Riprova',
    'auth.tooManySignInAttempts': 'Troppi tentativi di accesso. Riprova più tardi',
    'common.continueWithGoogleAlt': 'Continua con Google',
    'common.eventNotFoundAlt': 'Evento non trovato',
    'common.noUploadsAllowedAlt': 'Upload non consentiti',
    'common.pageTitleUploadPhotos': 'Carica Foto',
    'common.profileAlt': 'Profilo',
    'common.povLogoAlt': 'Logo POV',
    'common.submitAlt': 'Invia',
    'common.warningAlt': 'Avviso',
    'invalid.inputCannotBeEmpty': 'L\'input non può essere vuoto.',
    'upload.duplicatePhoto': 'Hai provato ad aggiungere una foto che hai già caricato',
    'upload.duplicatePhotos': 'Hai provato ad aggiungere foto che hai già caricato',
    'upload.errorInImage': 'Errore nell\'immagine {index}: {message}',
    'upload.hint.deleteSomeFirst': 'Per aggiungere altri upload, elimina prima alcuni elementi.',
    'upload.hint.rangeAfter': '{countLabel} scattate dopo {start} saranno accettate',
    'upload.hint.rangeBetween': '{countLabel} scattate tra {start} e {end} saranno accettate',
    'upload.hint.selectBestPhoto': 'Seleziona la tua foto migliore!',
    'upload.hint.selectBestPhotos': 'Seleziona le tue migliori {count} foto!',
    'upload.invalidTypePhoto': 'Una foto non è .PNG, .JPG o .HEIC. {hint}',
    'upload.invalidTypePhotos': '{count} foto non sono .PNG, .JPG o .HEIC. {hint}',
    'upload.moreErrors.one': '+1 altro errore',
    'upload.moreErrors.other': '+{count} altri errori',
    'upload.noValidPhotos': 'Nessuna foto valida da caricare. Riprova con foto diverse.',
    'upload.onePhoto': '1 foto',
    'upload.photoNoDate': 'Una foto non ha una data. {hint}',
    'upload.photoTakenAfterEventEnd': 'Una foto è stata scattata dopo la data di fine dell\'evento. Upload {validRange}',
    'upload.photoTakenBeforeEventStart': 'Una foto è stata scattata prima della data di inizio dell\'evento. Upload {validRange}',
    'upload.photosNoDate': '{count} foto non hanno una data. {hint}',
    'upload.photosTakenAfterDate': '{count} foto sono state scattate dopo {date}. Upload {validRange}',
    'upload.photosTakenBeforeDate': '{count} foto sono state scattate prima di {date}. Upload {validRange}',
    'upload.processingPhotos': 'Elaborazione di {current} su {total} foto',
    'upload.progressPhotosUploaded': '{current} di {total} foto caricate',
    'upload.rangeAfterAccepted': 'scattate dopo {start} saranno accettate',
    'upload.rangeBetweenAccepted': 'scattate tra {start} e {end} saranno accettate',
    'upload.selectBestPhoto': 'Seleziona la tua foto migliore!',
    'upload.selectBestPhotos': 'Seleziona le tue migliori {count} foto!',
    'upload.screenshotsNotAllowed': 'Gli screenshot non sono consentiti',
    'upload.takenAfterAccepted': '{prefix} scattate dopo {start} saranno accettate',
    'upload.takenBetweenAccepted': '{prefix} scattate tra {start} e {end} saranno accettate',
    'upload.successUploadedMany': '{count} foto caricate con successo! Te ne restano {remaining}',
    'upload.successUploadedOne': 'Foto caricata con successo! Te ne restano {remaining}',
    'upload.tooManyPhotosSelected': 'Troppe foto selezionate. {hint}',
    'upload.upToPhotos': 'Fino a {count} foto',
    'upload.uploadedSummary': 'Caricate {successful} immagini su {total}!',
    'upload.usedAllShotsDelete': 'Hai usato tutti i tuoi upload dal rullino! Elimina una foto se cambi idea',
    'upload.usedAllShotsTap': 'Hai usato tutti i tuoi upload dal rullino! Tocca una foto se cambi idea',
    'upload.willBeAccepted': 'saranno accettate'
  }
};

function getPluralCategory(locale, count) {
  try {
    return new Intl.PluralRules(locale).select(count);
  } catch (error) {
    return count === 1 ? 'one' : 'other';
  }
}

function interpolate(value, params = {}) {
  return String(value).replace(/\{(\w+)\}/g, (_, key) => {
    const replacement = params[key];
    return replacement == null ? '' : String(replacement);
  });
}

function normalizeLanguage(rawLang) {
  if (!rawLang || typeof rawLang !== 'string') {
    return 'en';
  }

  const normalized = rawLang.trim().toLowerCase().replace('_', '-');
  const aliases = {
    no: 'nb',
    'nb-no': 'nb',
    'nn-no': 'nb',
    'pt-br': 'pt',
    'pt-pt': 'pt',
    'es-419': 'es'
  };

  if (SUPPORTED_LANGS.includes(normalized)) {
    return normalized;
  }

  if (aliases[normalized]) {
    return aliases[normalized];
  }

  const base = normalized.split('-')[0];
  if (SUPPORTED_LANGS.includes(base)) {
    return base;
  }

  return 'en';
}

function getTranslationsForLanguage(lang) {
  const duplicate = IOS_DUPLICATE[lang] || {};
  const manual = MANUAL_TRANSLATIONS[lang] || {};
  const webMissing = WEB_MISSING_TRANSLATIONS[lang] || {};
  return {
    ...EN,
    ...duplicate,
    ...manual,
    ...webMissing
  };
}

function translate(lang, key, params = {}) {
  const language = normalizeLanguage(lang);
  const dictionary = getTranslationsForLanguage(language);
  const value = dictionary[key] ?? EN[key] ?? key;
  return interpolate(value, params);
}

function translatePlural(lang, keyPrefix, count, params = {}) {
  const language = normalizeLanguage(lang);
  const locale = LOCALE_BY_LANG[language] || LOCALE_BY_LANG.en;
  const category = getPluralCategory(locale, Number(count));
  const pluralKey = `${keyPrefix}.${category}`;
  const fallbackKey = `${keyPrefix}.${Number(count) === 1 ? 'one' : 'other'}`;
  const number = formatNumberForLanguage(language, count);
  return translate(language, pluralKey in getTranslationsForLanguage(language) ? pluralKey : fallbackKey, {
    ...params,
    count: number
  });
}

function getLanguageFromSearch(search = '') {
  try {
    const urlParams = new URLSearchParams(search);
    return urlParams.get('lang');
  } catch (error) {
    return null;
  }
}

function getPreferredLanguage(search = '') {
  const rawLang = getLanguageFromSearch(search);
  if (rawLang) {
    return normalizeLanguage(rawLang);
  }

  return 'en';
}

function getLocaleForLanguage(lang) {
  const language = normalizeLanguage(lang);
  return LOCALE_BY_LANG[language] || LOCALE_BY_LANG.en;
}

function formatNumberForLanguage(lang, value) {
  const locale = getLocaleForLanguage(lang);
  try {
    return new Intl.NumberFormat(locale).format(Number(value));
  } catch (error) {
    return String(value);
  }
}

function formatMonthNames(lang) {
  const locale = getLocaleForLanguage(lang);
  return Array.from({ length: 12 }, (_, index) => {
    const date = new Date(Date.UTC(2020, index, 1));
    return new Intl.DateTimeFormat(locale, { month: 'long', timeZone: 'UTC' }).format(date);
  });
}

function applyDocumentLanguage(lang) {
  if (typeof document !== 'undefined') {
    document.documentElement.lang = normalizeLanguage(lang);
  }
}

export {
  SUPPORTED_LANGS,
  normalizeLanguage,
  getPreferredLanguage,
  getLocaleForLanguage,
  formatNumberForLanguage,
  formatMonthNames,
  applyDocumentLanguage,
  translate,
  translatePlural
};
